"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComputeScore = exports.DefaultScoreEquationCoefficients = void 0;
/** Make sure to take a `structuredClone()` to avoid weird bugs from inadvertent modification! */
exports.DefaultScoreEquationCoefficients = {
    a: 1,
    b: 1,
    n: 2,
};
/** Applies the given coefficients to the absolute distance from the normal (`x`) */
const ComputeScore = (coefficients, x) => {
    const precision = getPrecision(x);
    const { a, b, n } = coefficients;
    if (x === 0)
        return 0;
    const score = a * x + b * Math.pow(x, n);
    const roundedScore = +score.toFixed(precision);
    return roundedScore;
};
exports.ComputeScore = ComputeScore;
/** https://stackoverflow.com/a/27865285 */
function getPrecision(value) {
    let n = value;
    if (typeof n !== 'number')
        n = parseFloat(n);
    if (isNaN(n))
        return 0;
    var e = 1;
    while (Math.round(n * e) / e !== n)
        e *= 10;
    return Math.round(Math.log(e) / Math.LN10);
}
